import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Transition } from "react-transition-group";
import { Animation } from "../../../../../components/Animation";
import Input from "../../../../../components/Form/Input";
import Button from "../../../../../components/Button";
import Icon from "../../../../../components/Icon";
import DragDropArea from "../DragDropArea";
import {
  ModalBackdrop,
  Modal,
  ModalDialog,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Title,
  Close,
  ModalAnimation,
  ErrorText,
} from "./styles";

import closeIcon from "../../../../../assets/icons/close_circled.svg";

interface Props {
  label: string; // Ej: "PDF", "Audio", etc.
  accept: string; // Ej: "application/pdf", "audio/*"
  onUpload: (file: File, title: string) => void;
  onClose: () => void;
}



const MAX_FILE_SIZE_MB = 2048; // 2GB in MB
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert MB to bytes
//aca quiero hacer una funcion que me calcule un string de cuantos mb o gb representa

const getDisclaimerText = (label: string) => {
  switch (label.toLowerCase()) {
    case "audio":
      return "Formatos permitidos: mp3, ogg. Peso máximo: 2GB.";
    case "pdf":
      return "Solo archivos PDF. Peso máximo: 2GB.";
    case "imagen":
      return "Formatos permitidos: JPG, PNG, WebP. Peso máximo: 100MB.";
    default:
      return "Peso máximo: 2GB.";
  }
};

const InsertMediaModal = ({ label, accept, onUpload, onClose }: Props) => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const handler = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  // Gestión de estilos del body/HTML cuando el modal está abierto
  useEffect(() => {
    // Aplicar estilos cuando el modal se monta
    document.body.style.height = "100%";
    document.body.style.overflow = "hidden";
    document.documentElement.style.height = "100%";
    document.documentElement.style.overflow = "hidden";

    // Limpiar estilos cuando el modal se desmonta
    return () => {
      document.body.style.height = "auto";
      document.body.style.overflow = "auto";
      document.documentElement.style.height = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, []);

  const handleBackdropClick = () => {
    onClose();
  };

  const handleInsert = () => {
    // if (!title.trim()) {
    //   setError(`Debes ingresar un título para el ${label}`);
    //   return;
    // }

    if (!file || !file.type.startsWith(accept.split("/")[0])) {
      setError(`Debes seleccionar un archivo ${label} válido`);
      return;
    }

    setError("");
    onUpload(file, title.trim());
    onClose();
  };
  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const modalDOM = document.getElementById("modal") as HTMLElement;

  if (!modalDOM) {
    return null;
  }

  return ReactDOM.createPortal(
    <Transition in={true} timeout={350} mountOnEnter>
      {(state) => (
        <>
          <ModalAnimation
            name="fadeIn"
            className={`animation-${state}`}
          >
            <Modal>
              <ModalDialog width={420}>
                <ModalContent>
                  <ModalHeader>
                    <Close onClick={onClose}>
                      <Icon
                        icon={closeIcon}
                        size="24px"
                        color="black"
                      />
                    </Close>
                    <Title>Insertar {label}</Title>
                  </ModalHeader>

                  <ModalBody>
                    <Input
                      name={`${label.toLowerCase()}Title`}
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder={`Ej: "Título del ${label}"`}
                      options={{
                        label: `Título del ${label}`,
                        size: "md",
                        skin: "base",
                        marginBottom: 12,
                      }}
                    />

                    <DragDropArea
                      accept={accept}
                      onFileSelect={(selectedFile) => {
                        setFile(selectedFile);
                        setError("");
                      }}
                      onError={(errorMsg) => setError(errorMsg)}
                      placeholder={`O arrastrá un archivo ${label} aquí`}
                      helperText={getDisclaimerText(label)}
                      maxSize={2048} // 2GB in MB
                      buttonText={`Seleccionar ${label}`}
                    />
                  </ModalBody>

                  <ModalFooter>
                    <Button
                      type="button"
                      onClick={onClose}
                      options={{
                        type: "outline",
                        size: "md",
                        skin: "purple",
                      }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      type="button"
                      onClick={handleInsert}
                      options={{
                        type: "filled",
                        size: "md",
                        skin: "purple",
                      }}
                      disabled={!file}
                    >
                      Insertar
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </ModalDialog>
            </Modal>
          </ModalAnimation>

          <Animation name="fadeIn" className={`animation-${state}`}>
            <ModalBackdrop onClick={handleBackdropClick} />
          </Animation>
        </>
      )}
    </Transition>,
    modalDOM
  );
};

export default InsertMediaModal;
